import { Injectable } from '@angular/core';
import { SectionKey } from '@root/app.interfaces';
import { CdkAccordionItem } from '@angular/cdk/accordion';

@Injectable({
	providedIn: 'root',
})
export class AccordionSectionService<K extends SectionKey> {
	constructor() {}
	private registry = new Map<K, CdkAccordionItem>();

	register(key: K, item: CdkAccordionItem): void {
		this.registry.set(key, item);
	}

	isOpen(key: K): boolean {
		return this.registry.get(key)?.expanded ?? false;
	}

	open(key: K, closeOthers = false): void {
		if (closeOthers) {
			this.closeAllExcept(key);
		}
		this.registry.get(key)?.open();
	}

	close(key: K): void {
		this.registry.get(key)?.close();
	}

	toggle(key: K, closeOthers = false): void {
		const item = this.registry.get(key);
		if (!item) {
			return;
		}

		if (closeOthers && !item.expanded) {
			this.closeAllExcept(key);
		}

		item.toggle();
	}

	closeAll(): void {
		this.registry.forEach((item) => item.close());
	}

	private closeAllExcept(sectionKey: K): void {
		this.registry.forEach((item, key) => {
			if (key !== sectionKey) {
				item.close();
			}
		});
	}
}
